module.exports = __webpack_public_path__ + "static/media/services_smartdevice.9d4ec17e.jpg";